import { AddressComponent } from 'app/modules/survey/survey-viewer/survey-question/types/address/address.component'
import { QuestionComponent } from 'app/models/questions/QuestionComponent'
import { Props } from 'app/models/questions/Props'
import { UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms'
import { IFullAddress } from 'app/interfaces/IFullAddress'
import { requireCommentOnOpenSelection } from 'app/form-validators/RequireCommentOnOpenSelectionValidator'
import { addressValidator } from 'app/form-validators/AddressValidator'
import { LoremIpsum } from 'lorem-ipsum'

export class Address extends Props {
  private readonly _addressFormControlName = 'info_address'

  fillFormWithDummyAnswer(surveyForm) {
    this.resetForm(surveyForm)

    this.setEverySelectedControlToTrueForGivenRow(surveyForm, this.rowKeys[this.rowKeys.length - 1])
    this.buildRandomValidAnswer(surveyForm)
  }

  getDisplayComponent(): QuestionComponent {
    return new QuestionComponent(AddressComponent, this)
  }

  resetForm(surveyForm: UntypedFormGroup) {
    surveyForm.enable({emitEvent: false})

    let emptyMatrixAnswers = {}

    this.rowKeys.forEach(rKey => {
      if (!emptyMatrixAnswers[rKey]) {
        emptyMatrixAnswers[rKey] = {}
        emptyMatrixAnswers[rKey][this.formControlName] = {}
        emptyMatrixAnswers[rKey][this.commentsControlName] = {}
      }
      this.statementKeys.forEach(sKey => {
        emptyMatrixAnswers[rKey][this.formControlName][sKey] = false
        emptyMatrixAnswers[rKey][this.commentsControlName][sKey] = Address.buildEmptyAddressFormState()
      })
    })

    surveyForm.controls[this.key].reset(emptyMatrixAnswers, {emitEvent: false})
  }

  buildQuestionFormGroup(): UntypedFormGroup {
    const formGroup = new UntypedFormGroup({})

    this.rowsOrder.forEach(rKey => {
      const validators = this.isOptional ? [] : [requireCommentOnOpenSelection(this.formControlName, this.commentsControlName, this.getOpenStatementsForRow(rKey))]
      let statementFormGroup = new UntypedFormGroup({
        [this.formControlName]: new UntypedFormGroup({
          [this.addressFormControlName]: new UntypedFormControl(true)
        }),
        [this.commentsControlName]: this.buildAddressCommentFormGroup()
      }, validators)
      formGroup.addControl(rKey, statementFormGroup)
    })

    return formGroup
  }

  static buildEmptyAddressFormState(): IFullAddress {
    return {
      Label: '',
      Line1: '',
      Id: '',
      City: '',
      PostalCode: '',
      BuildingNumber: '',
      Street: '',
      CountryName: '',
      ProvinceName: '',
      Province: '',
      ProvinceCode: '',
      SubBuilding: '',
      userConfirmed: false
    }
  }

  private static generatePostalCode(): string {
    let postalCode: string = ''
    for (let i = 0; i < 6; i++) {
      if (i % 2) {
        postalCode = postalCode.concat(new LoremIpsum().generator.generateRandomInteger(1, 9).toString())
      } else {
        postalCode = postalCode.concat(new LoremIpsum().generateWords(1).slice(0, 1).toUpperCase())
      }
    }
    return postalCode
  }

  private buildRandomValidAnswer(surveyForm) {
    const validAnswer = {
      Label: new LoremIpsum().generateWords(1),
      Line1: new LoremIpsum().generateWords(1),
      Id: new LoremIpsum().generateWords(1),
      City: new LoremIpsum().generateWords(1),
      PostalCode: Address.generatePostalCode(),
      BuildingNumber: Math.random().toString().slice(2, 5),
      Street: new LoremIpsum().generateWords(1),
      CountryName: new LoremIpsum().generateWords(1),
      ProvinceName: new LoremIpsum().generateWords(1),
      Province: new LoremIpsum().generateWords(1),
      ProvinceCode: new LoremIpsum().generateWords(1),
      SubBuilding: Math.random().toString().slice(2, 6),
      userConfirmed: true
    }

    surveyForm.controls[this.key].get(this.rowKeys.pop()).get(this.commentsControlName).get(this.addressFormControlName).setValue(validAnswer, {emitEvent: false})
  }

  private buildAddressCommentFormGroup(): UntypedFormGroup {
    const form = new UntypedFormGroup({})
    const validators = this.addValidators()
    form.addControl(this.addressFormControlName, new UntypedFormGroup({
      Label: new UntypedFormControl(''),
      Line1: new UntypedFormControl(''),
      Id: new UntypedFormControl(''),
      City: new UntypedFormControl(''),
      PostalCode: new UntypedFormControl(''),
      BuildingNumber: new UntypedFormControl(''),
      Street: new UntypedFormControl(''),
      CountryName: new UntypedFormControl(''),
      ProvinceName: new UntypedFormControl(''),
      Province: new UntypedFormControl(''),
      ProvinceCode: new UntypedFormControl(''),
      SubBuilding: new UntypedFormControl(''),
      userConfirmed: new UntypedFormControl(false)
    }, {validators}))

    return form
  }

  private addValidators(): ValidatorFn[] {
    let validators: ValidatorFn[] = [addressValidator(this.isOptional)]

    if (!this.isOptional ) {
      validators.push(Validators.required)
    }

    return validators
  }

  get addressFormControlName() {
    return this._addressFormControlName
  }
}
